export const FETCH_FAV_LINES_M = 'FETCH_FAV_LINES_M';
export const FETCH_FAV_LINES_SUCCESS_M = 'FETCH_FAV_LINES_SUCCESS_M';
